import React from "react";
import { reduxForm } from "redux-form";
import { goTo } from "../tools";
import closeIcon from '../img/close-icono.png';
import warningIcon from '../img/warning-icono.png';

class ModalClaveExpirado extends React.Component {

    componentDidMount = () => {
		$("#clave-caducada").modal({ backdrop: "static", keyboard: true });
	}

    cerrarModal = () => {
        localStorage.setItem("claveCaducado", false);
		$("#clave-caducada").modal('hide');
		goTo("/gnp/gnp-olvide-contrasenia");
	}

    render() {
        return <div>
            <div className="modal fade" id="clave-caducada" tabIndex="-1" role="dialog">
                <div className="modal-dialog clave-caducada" id="clave-caducada" role="document">
                    <img src={closeIcon} id="icon-close" onClick={this.cerrarModal} />
                    <div style={{ textAlign: "center" }}>
                        <img src={warningIcon} id="icon-warning" />
                    </div>
                    <div className="modal-header-otp">
                        <h4>Clave de acceso caducada</h4>
                    </div>
                    <div id="txt-mensaje">
                        <label id="label-mensaje">El límite de tiempo para usar tu clave ha vencido. Solicita una nueva para que
                            puedas seguir usando tu app Soy Cliente GNP
                        </label>
                    </div>
                    <div id="btn-otra-clave">
                        <button id="btn-validar" type="button" onClick={this.cerrarModal}
                            style={{ "color": "#FFFFFF" }} className="orange-btn texto-otp"
                        >Quiero otra clave de acceso</button>
                    </div>
                </div>
            </div>
        </div>;
    }
}

ModalClaveExpirado = reduxForm({ form: "datosPassword" })(ModalClaveExpirado);
export default (ModalClaveExpirado);



// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/modal-clave-caducada.cmpt.js